import { render, staticRenderFns } from "./printing.vue?vue&type=template&id=60651318&scoped=true&"
import script from "./printing.vue?vue&type=script&lang=js&"
export * from "./printing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60651318",
  null
  
)

export default component.exports